const LoaderPopup = () => {
  return (
    <div className='h-full w-full bg-black bg-opacity-50 rounded-t-2xl absolute top-0 left-0 flex justify-center items-center'>
      <span className="loader-popup-internal"></span>
    </div>

  )
}

export default LoaderPopup